import MDBox from "components/Basics/MDBox";
import MDTypography from "components/Basics/MDTypography";

const ComparisonTopFlopTableDisplay = ({ chart, data }) => {
	const top = chart.request.limit ?? 3;

	return (
		<MDBox m={2} display="flex" flexDirection="row" justifyContent="space-between">
			<MDBox flex="1" mr={1}>
				<MDTypography variant="h6">Top</MDTypography>
				{(data?.ranking?.positives ?? []).map((item, index) => {
					return (
						<MDBox
							key={index}
							display="flex"
							flexDirection="row"
							justifyContent="space-between"
							alignItems="center"
							bgColor="light"
							borderRadius="md"
							p={1}
							mb={1}
						>
							<MDTypography>{item.name}</MDTypography>
							<MDTypography color="success" fontWeight="bold">
								{`${item.value} avis positif${item.value > 1 ? "s" : ""}`}
							</MDTypography>
						</MDBox>
					);
				})}
			</MDBox>
			<MDBox flex="1" ml={1}>
				<MDTypography variant="h6">Flop</MDTypography>
				{(data?.ranking?.negatives ?? []).map((item, index) => {
					return (
						<MDBox
							key={index}
							display="flex"
							flexDirection="row"
							justifyContent="space-between"
							alignItems="center"
							bgColor="light"
							borderRadius="md"
							p={1}
							mb={1}
						>
							<MDTypography>{item.name}</MDTypography>
							<MDTypography color="error" fontWeight="bold">
								{`${item.value} avis négatif${item.value > 1 ? "s" : ""}`}
							</MDTypography>
						</MDBox>
					);
				})}
			</MDBox>
		</MDBox>
	);
};

export default ComparisonTopFlopTableDisplay;
